import {
  IDropdownOptions,
  PaymentMethodsTypes,
  PaymentMethodsTypesThatNeedReturnTypes,
} from '@/Interfaces/Data';

export const paymentMethods: Record<PaymentMethodsTypes, string> = {
  DINHEIRO: 'Dinheiro',
  DEBITO: 'Débito',
  CREDITO: 'Crédito',
  ONLINE: 'Pag. on-line',
};

export const paymentMethodsThatNeedReturn: Record<
  PaymentMethodsTypesThatNeedReturnTypes,
  string
> = {
  DINHEIRO: 'Dinheiro',
  DEBITO: 'Débito',
  CREDITO: 'Crédito',
};

export const paymentMethodsThatNeedReturnOptions: IDropdownOptions<string>[] = [
  {
    key: 'DINHEIRO',
    value: 'DINHEIRO',
    text: 'Dinheiro',
  },
  {
    key: 'DEBITO',
    value: 'DEBITO',
    text: 'Débito',
  },
  {
    key: 'CREDITO',
    value: 'CREDITO',
    text: 'Crédito',
  },
];
